<template>
  <base-layout>
    <template v-slot:header> </template>

    <template v-slot:default>
      <router-view v-slot="{ Component }" :key="$route.fullPath">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </template>

    <template v-slot:footer> </template>
  </base-layout>
</template>

<script>
import BaseLayout from "@/layout/BaseLayout";

export default {
  name: "App",
  components: { BaseLayout }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-active {
  opacity: 0;
}
</style>